export default __webpack_public_path__ + "static/media/farm.ca8a007b.png";